import { Link, useNavigate } from 'react-router-dom';
import { Badges, Image, P, SVG } from '../../../AbstractElements';
import { Href } from '../../../utils/Constant';
import { Rating } from 'react-simple-star-rating';
import { dynamicImage } from '../../../Service';
import { TableColumn } from 'react-data-table-component';
import {
    ProductListTableDataColumnType,
    ProductListTableProduct
} from '../../../Types/Application/Ecommerce/Ecommerce';
import { Product } from '../../../Types/Products';
import { productsApi } from '../../../Api';
import { notification, Popconfirm } from 'antd';
import { numberToVND } from '../../../utils/helper/functions';
import { toast } from 'react-toastify';

export const productListTableData = [
    {
        image: 'dashboard-8/product-categories/laptop.png',
        name: 'Apple Desktop 2024',
        sku: '02145YK796',
        category: 'Laptops',
        price: 56000.0,
        quantity: 13,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'dashboard-8/product-categories/phone.png',
        name: 'Apple iphone 13 Pro',
        sku: '56379FG3AW',
        category: 'Smart Phones',
        price: 19000.0,
        quantity: 48,
        status: 'In Stock',
        rating: 3
    },
    {
        image: 'dashboard-8/product-categories/headphone.png',
        name: 'Headphones',
        sku: '33KR5689B1',
        category: 'Smart Headphones',
        price: 10000.0,
        quantity: 5,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/wireless-headphone.png',
        name: 'Wireless-headphone',
        sku: 'AD6789HEY0',
        category: 'Smart Headphones',
        price: 15000.0,
        quantity: 4,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'dashboard-2/product/1.png',
        name: 'Wood Chair',
        sku: '456DF78DFQ',
        category: 'Furniture',
        price: 99000.0,
        quantity: 2,
        status: 'Sold Out',
        rating: 5
    },
    {
        image: 'email-template/4.png',
        name: 'Wood Chair',
        sku: '5633GD3K54',
        category: 'Furniture',
        price: 1000.0,
        quantity: 8,
        status: 'Sold Out',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/ipad.png',
        name: 'MacBook Air 13.3-inch',
        sku: '589KO8PPQ8',
        category: 'Laptops',
        price: 45000.0,
        quantity: 10,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'dashboard-8/product-categories/mouse.png',
        name: 'M185 Compact Wireless Mouse',
        sku: '02145YK796',
        category: 'E-Commerce',
        price: 56000.0,
        quantity: 13,
        status: 'Sold Out',
        rating: 3
    },
    {
        image: 'other-images/cart-img.jpg',
        name: 'Wood chairs',
        sku: '568GH3LLQ2',
        category: 'Furniture',
        price: 78000.0,
        quantity: 50,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/watch.png',
        name: 'Smart watch',
        sku: '58FR7K34F6',
        category: 'Electric',
        price: 25000.0,
        quantity: 48,
        status: 'Sold Out',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/dvd.png',
        name: 'DVD',
        sku: 'HG5667DFQ1',
        category: 'Electric',
        price: 5600.0,
        quantity: 10,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/speaker.png',
        name: 'Speakers',
        sku: '02145YK796',
        category: 'Electric',
        price: 12200.0,
        quantity: 50,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'dashboard-8/product-categories/phone.png',
        name: 'Apple iphone 13 Pro',
        sku: '56379FG3AW',
        category: 'Smart Phones',
        price: 19000.0,
        quantity: 48,
        status: 'In Stock',
        rating: 3
    },
    {
        image: 'dashboard-8/product-categories/headphone.png',
        name: 'Headphones',
        sku: '33KR5689B1',
        category: 'Smart Headphones',
        price: 10000.0,
        quantity: 5,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'other-images/cart-img.jpg',
        name: 'Wood chairs',
        sku: '568GH3LLQ2',
        category: 'Furniture',
        price: 78000.0,
        quantity: 50,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/watch.png',
        name: 'Smart watch',
        sku: '58FR7K34F6',
        category: 'Electric',
        price: 25000.0,
        quantity: 48,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'dashboard-8/product-categories/phone.png',
        name: 'Apple iphone 13 Pro',
        sku: '56379FG3AW',
        category: 'Smart Phones',
        price: 19000.0,
        quantity: 48,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/headphone.png',
        name: 'Headphones',
        sku: '33KR5689B1',
        category: 'Smart Headphones',
        price: 10000.0,
        quantity: 5,
        status: 'In Stock',
        rating: 3
    },
    {
        image: 'dashboard-8/product-categories/wireless-headphone.png',
        name: 'Wireless-headphone',
        sku: 'AD6789HEY0',
        category: 'Smart Headphones',
        price: 15000.0,
        quantity: 4,
        status: 'Sold Out',
        rating: 5
    },
    {
        image: 'dashboard-2/product/1.png',
        name: 'Wood Chair',
        sku: '456DF78DFQ',
        category: 'Furniture',
        price: 99000.0,
        quantity: 2,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'email-template/4.png',
        name: 'Wood Chair',
        sku: '5633GD3K54',
        category: 'Furniture',
        price: 1000.0,
        quantity: 8,
        status: 'Sold Out',
        rating: 3
    },
    {
        image: 'dashboard-8/product-categories/laptop.png',
        name: 'Apple Desktop 2024',
        sku: '02145YK796',
        category: 'Laptops',
        price: 56000.0,
        quantity: 13,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'dashboard-8/product-categories/phone.png',
        name: 'Apple iphone 13 Pro',
        sku: '56379FG3AW',
        category: 'Smart Phones',
        price: 19000.0,
        quantity: 48,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/headphone.png',
        name: 'Headphones',
        sku: '33KR5689B1',
        category: 'Smart Headphones',
        price: 10000.0,
        quantity: 5,
        status: 'In Stock',
        rating: 5
    },
    {
        image: 'dashboard-8/product-categories/wireless-headphone.png',
        name: 'Wireless-headphone',
        sku: 'AD6789HEY0',
        category: 'Smart Headphones',
        price: 15000.0,
        quantity: 4,
        status: 'Sold Out',
        rating: 4
    },
    {
        image: 'dashboard-2/product/1.png',
        name: 'Wood Chair',
        sku: '456DF78DFQ',
        category: 'Furniture',
        price: 99000.0,
        quantity: 2,
        status: 'Sold Out',
        rating: 2
    }
];

const ProductListTableAction = ({ id }: { id: any }) => {
    const navigate = useNavigate();
    return (
        <div className="product-action">
            <SVG
                iconId="edit-content"
                onClick={() => navigate(`${process.env.PUBLIC_URL}/products/detail/${id}`)}
            />
            <Popconfirm
                title="Delete the product"
                description="Are you sure to delete this product?"
                onConfirm={() => {
                    productsApi
                        .delete(id)
                        .then((res) => {
                            toast.success("Delete success");
                            navigate(`${process.env.PUBLIC_URL}/products`);
                        })
                        .catch((err) => {
                            toast.warning("Something has occurred !!!");
                            console.error(err);
                        });
                }}
                okText="Yes"
                cancelText="No">
                <div>
                    <SVG iconId="trash1" />
                </div>
            </Popconfirm>
        </div>
    );
};

const ProductListTableProductName: React.FC<ProductListTableProduct> = ({ images, name }) => {    
    return (
        <div className="product-names my-2">
            <div className="light-product-box">
                <Image
                    style={{ height: '100%' }}
                    className="img-fluid"
                    src={images}
                    alt=""
                />
            </div>
            <P>{name}</P>
        </div>
    );
};

const ProductListTableStatus: React.FC<ProductListTableProduct> = ({ name }) => {
    return (
        <Badges
            color="transparent"
            className={`badge-light-${name === 'Sold Out' ? 'secondary' : 'primary'}`}>
            {name}
        </Badges>
    );
};

const ProductListTableRating: React.FC<ProductListTableProduct> = ({ rate }) => {
    return (
        <Rating
            initialValue={rate}
            size={17}
            fillColor="#FFAE1A"
        />
    );
};

export const productListTableDataColumn: TableColumn<Product>[] = [
    {
        name: 'Product Name',
        cell: (row) => (
            <ProductListTableProductName
                images={row.images ? (row.images.length > 0 ? row.images[0] : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUSMS78r_Ii9QDIN03CqowvLCY1j6VuBUaFA&s') : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUSMS78r_Ii9QDIN03CqowvLCY1j6VuBUaFA&s'}
                name={row.name}
            />
        ),
        sortable: true,
        grow: 2
    },
    {
        name: 'Description',
        selector: (row) => `${row.description}`,
        sortable: true,
        grow: 2
    },
    {
        name: 'Price',
        selector: (row) => `${numberToVND(Number(row.price))}`,
        sortable: true
    },
    {
        name: 'Original Price',
        selector: (row) => `${numberToVND(Number(row.original_price))}`,
        sortable: true
    },
    {
        name: 'Brand',
        selector: (row) => `${row.brand}`,
        sortable: true
    },
    {
        name: 'Status',
        cell: (row) => <ProductListTableStatus name={row.in_stock ? 'In Stock' : 'Sold Out'} />
    },
    {
        name: 'Rating',
        cell: (row) => <ProductListTableRating rate={row.rating} />
    },
    {
        name: 'Action',
        cell: (row) => <ProductListTableAction id={row.id} />
    }
];

export const filtersData = [
    {
        name: 'Choose Product',
        options: ['Apple iphone 13 Pro', 'Wood Chair', 'M185 Compact Wireless Mouse']
    },
    {
        name: 'Choose Category',
        options: ['Furniture', 'Smart Gadgets', 'Electrics']
    },
    {
        name: 'Choose Sub Category',
        options: ['Smart Phones', 'Smart Watches', 'Wireless headphone']
    },
    {
        name: 'Status',
        options: ['Sold Out', 'In Stock', 'Pre Order', 'Limited Stock']
    },
    {
        name: 'Price',
        options: ['56000.00', '19000.00', '10000.00', '15000.00', '99000.00']
    }
];
